import HttpClient from "utils/HttpClient/HttpClient"
import { SUCCESSFUL_GET_PAYMENTPLAN, UPDATE_SALEORDER } from "./actionConst";
import { SHOW_ERROR_MESSAGE } from 'reducers/application/actionConst';

export const fetchPaymentPlan = (saleOrderId) => dispatch => {
    if (saleOrderId == 0) {
        dispatch({
            type: SUCCESSFUL_GET_PAYMENTPLAN,
            payload: []
        });
        return;
    }
    new HttpClient(true).get("b2c/paymentplan",
        {
            params: {
                saleOrderId: saleOrderId
            }
        })
        .then((response) => {
            console.log("Successful Fetch PaymentPlan");
            dispatch({
                type: SUCCESSFUL_GET_PAYMENTPLAN,
                payload: response.data
            });
        })
        .catch((error) => {
            console.log("Failed Fetch PaymentPlan");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        })
}

export const updateSaleOrderAtPaymentPlan = (saleOrder) => dispatch => {
    dispatch({
        type: UPDATE_SALEORDER,
        payload: saleOrder
    });
}



// WEBPACK FOOTER //
// ./src/reducers/paymentplan/paymentplanActions.js